import { getSvgComponent } from "../../utils/svgUtils";
import "./styles.scss";

export const CustomImage = ({
  image,
  classNames,
  styles,
  activeIndex,
  imageContainerClass,
  isCampaignSvg,
}) => {
  if (image?.length > 0 && activeIndex !== undefined) {
    return image.map((img, index) => {
      if (index === activeIndex) {
        return (
          <div className={imageContainerClass} key={index}>
            <img
              src={isCampaignSvg ? getSvgComponent(img) : img}
              alt={img}
              className={`${classNames}`}
              style={styles}
            />
          </div>
        );
      }
      return null;
    });
  } else {
    return (
      <img
        src={image}
        alt={image}
        className={`custom-image ${classNames}`}
        style={styles}
      />
    );
  }
};
